<div class="pt-5 bg-white">
    <div class="row ml-0">
        <div class="col-1"></div>
        <div class="col-7">
            <div class="d-flex">
                <div>
                    <div class="header-content">
                        Analytics
                    </div>
                    <div class="sub-content mt-3">
                        Hello. Here, you can select and download the analytics details.
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 d-flex justify-content-end">
            <button class="btn d-flex justify-content-center ml-3 primary-bg text-white" style="width:200px;height: calc(1.5em + 0.75rem + 2px);" (click)="downloadAnalytics()" [disabled]="disableDownload()"><mat-icon style="margin-right: 10px;">file_download</mat-icon> <span>Download</span></button>
        </div>
        <div class="col-1"></div>
    </div>
    <div class="row ml-0 pt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <div class="d-flex align-items-center">
                <mat-checkbox id="analytics-select-all" [checked]="selectAllAnalytics" [indeterminate]="checkSelectAll()" (change)="setSelectAllAnalytics($event.checked)">
                </mat-checkbox>
                <span class="primary-txt font-15" style="margin-top: -8px;margin-left: 10px;">
                    Select All
                </span>
            </div>
            <div class="pt-4">
                <div *ngFor="let file of fileList;" class="file-card">
                    <mat-checkbox [(ngModel)]="file.selected" (ngModelChange)="updateAllAnalytics()" class="check-box"></mat-checkbox>
                    <div class="file-img-holder"><img class="file-img" src="../../assets/img/analytics.svg" /></div>
                    <div class="file-name">{{file.fileName}}</div>
                </div>
            </div>
        </div>
        <div class="col-1"></div>
    </div>
</div>
<!-- <div class="row">
    <div class="col-1"></div>
    <div class="col-10 d-flex justify-content-center align-items-center" style="height: 100vh;">

    </div>
    <div class="col-1"></div>
</div> -->